<!-- MP看板 账号 表格 -->
<template>
	<div class="table-box" >
		<!-- 表头 -->
		<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
			<div class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':30 + 'px'}">
					<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
				</div>
				<template v-for="(item,index) in rableTitle" name="item.type">
					<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[index].width + 'px'}" >
						{{rableTitle[index].title}}
					</div>
				</template>
				
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
	
				<div v-if="index > sticky_index && item.show_control" class="table-th-cell" 
				:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
				@click="sortClick(index)">
					{{item.title}}
					<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
			<!-- 占位，隔出一个空白区域 -->
			<div id="" style="padding:15px;"></div>
		</div>
		
		<!-- 总计 -->
		<div v-if="tableShowData.length > 0" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':30 + 'px'}">
					
				</div>
				<div class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}">
					总计
				</div>
				<div class="table-td-cell"
				:style="{'width':rableTitle[1].width + 'px'}" >
				</div>
				<div  class="table-td-cell"
				:style="{'width':rableTitle[2].width + 'px'}">
				</div>
				<div  class="table-td-cell"
				:style="{'width':rableTitle[3].width + 'px'}">
				</div>
				<div  class="table-td-cell"
				:style="{'width':rableTitle[4].width + 'px'}">
				</div>
			</div>
			<!-- 消耗 -->
			<div class="table-td-cell"  :class="{'text-right': rableTitle[5].text_right}" :style="{'width': rableTitle[5].width + 'px'}">
				{{tableSumData.cost || 0}}
			</div>
			<!-- 展示数 -->
			<div v-show="!jj_checked" class="table-td-cell text-right"  :style="{'width': rableTitle[6].width + 'px'}">
				{{tableSumData.show || 0}}
			</div>
			<!-- ecpm -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[7].width + 'px'}" >
				{{tableSumData.avg_show_cost | tableToFixed}}
			</div>
			<!-- 点击数 -->
			<div  v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[8].width + 'px'}">
				{{tableSumData.click || 0}}
			</div>
			<!-- 平均点击单价 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[9].width + 'px'}">
				{{tableSumData.avg_click_cost | tableToFixed}}
			</div>
			<!-- 点击率 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[10].width + 'px'}">
				{{tableSumData.ctr | tableToFixed}}
			</div>
			
			<!-- 公众号关注数 -->
			<div v-if="page_type == 'mp'" class="table-td-cell text-right" :style="{'width': rableTitle[11].width + 'px'}">
				<!-- mp部分的 -->
				{{tableSumData.follow_count || 0}}
			</div>
			<div v-else class="table-td-cell text-right" :style="{'width': rableTitle[11].width + 'px'}">
				<!-- adq部分的 -->
				{{tableSumData.from_follow_uv || 0}}
			</div>
			<!-- 公众号关注成本 -->
			<div v-if="page_type == 'mp'" class="table-td-cell text-right" :style="{'width': rableTitle[12].width + 'px'}">
				<!-- mp部分的 -->
				{{tableSumData.follow_cost | tableToFixed}}
			</div>
			<div v-else class="table-td-cell text-right" :style="{'width': rableTitle[12].width + 'px'}">
				<!-- adq部分的 -->
				{{tableSumData.from_follow_cost | tableToFixed}}
			</div>
			
			<!-- 公众号关注数(微信) -->
			<div v-if="page_type == 'adq'" class="table-td-cell text-right" :style="{'width': rableTitle[11].width + 'px'}">
				{{tableSumData.follow_count || 0}}
			</div>
			<!-- 公众号关注成本(微信) -->
			<div v-if="page_type == 'adq'" class="table-td-cell text-right" :style="{'width': rableTitle[12].width + 'px'}">
				{{tableSumData.follow_cost | tableToFixed}}
			</div>
			
			<!-- 转化数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[13+2].width + 'px'}">
				{{tableSumData.conversions_count || 0}}
			</div>
			<!-- 平均转化成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[14+2].width + 'px'}">
				{{tableSumData.conversions_cost | tableToFixed}}
			</div>
			<!-- 转化率 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[15+2].width + 'px'}">
				{{tableSumData.conversions_rate | tableToFixed}}
			</div>
			<!-- 总充值金额 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[16+2].width + 'px'}">
				{{tableSumData.eff_total_pay_money || 0}}
			</div>
			<!-- 分成金额 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[17+2].width + 'px'}">
				{{tableSumData.eff_total_left_money || 0}}
			</div>
			<!-- 首充分成金额 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[18+2].width + 'px'}">
				{{tableSumData.eff_total_left_money_fisrt || 0}}
			</div>
			<!-- ROI -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[19+2].width + 'px'}">
				{{tableSumData.eff_roi*100 | tableToFixed}}%
			</div>
			<!-- 首充ROI -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[20+2].width + 'px'}">
				{{tableSumData.eff_roi_first*100 | tableToFixed}}%
			</div>
			
			<!-- 当天订单笔数 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[21+2].width + 'px'}">
				{{tableSumData.eff_total_order_cnt || 0}}
			</div>
			<!-- 当天充值用户数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[22+2].width + 'px'}">
				{{tableSumData.eff_total_pay_user_cnt || 0}}
			</div>
			<!-- 当天充值用户成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[23+2].width + 'px'}">
				{{tableSumData.eff_total_pay_user_cost | tableToFixed}}
			</div>
			<!-- ARPU -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[24+2].width + 'px'}">
				{{tableSumData.arpu | tableToFixed}}
			</div>
			<!-- 回传用户数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[25+2].width + 'px'}">
				{{tableSumData.eff_report_pay_user_cnt || 0}}
			</div>
			<!-- 回传用户成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[26+2].width + 'px'}">
				{{tableSumData.eff_report_pay_user_cost | tableToFixed}}
			</div>
			
			
			
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':30 + 'px'}">
					<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
				</div>
				<div  @click='operation(1,item)' class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}" style="color: #2F88FF;">
					{{item.account_name}}
				</div>
				<div @click='operation(2,item)' class="table-td-cell"
				:style="{'width':rableTitle[1].width + 'px'}">
					<div v-if="Object.keys(item.admin_user).length > 0" style="display: flex;align-items: center;cursor: pointer;flex-wrap: wrap;">
						<div v-for="(value,key) in item.admin_user" :key="key" style="color: #2F88FF;margin: 0 7px 3px 0;">
							{{value}}
						</div>
					</div>
					<div v-else style="color: #62a8ea;cursor: pointer;">
						未设置
					</div>
					
				</div>
				<!-- 推广平台 -->
				<div @click='operation(3,item)' class="table-td-cell"
				:style="{'width':rableTitle[2].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
					<div v-if="item.content_channel || item.book_name">
						<div>{{item.content_channel}}</div>
						<div>{{item.book_name}}</div>
					</div>
					<div v-else >
						未设置
					</div>
				</div>
				<!-- 开启同步数据 -->
				<div  class="table-td-cell"
				:style="{'width':rableTitle[3].width + 'px'}">
					<a-switch size="small" :checked="item.sync_checked" default-checked @change="onSyncCheckbox($event,item)"  checked-children="开启" un-checked-children="关闭"/>
				</div>
				
				<div  class="table-td-cell"
				:style="{'width':rableTitle[4].width + 'px'}">
					<a-popover :visible="item.popover_clicked" @visibleChange="handleClickChange($event,item)" trigger="click" placement="bottom">
						<template slot="content">
						  <div>
							  <div @click="zhOperation(3,item)" class='cz-button-calss'>查看计划</div>
							  <div @click="zhOperation(2,item)" class='cz-button-calss'>查看广告</div>
							  <div @click="zhOperation(1,item)" class='cz-button-calss'>同步账户信息</div>
							  <div @click="zhOperation(5,item)" class='cz-button-calss'>同步历史数据</div>
						  </div>
						</template>
						
						<!-- <a-icon style="font-size: 18px;font-weight: bold;cursor: pointer;" type="more" /> -->
						<div style="cursor: pointer;">查看/同步</div>
					</a-popover>
					
				</div>
			</div>
			<!-- 消耗 -->
			<div @mouseenter='TDmouseenter(index)' class="table-td-cell"  :class="{'text-right': rableTitle[5].text_right}" :style="{'width': rableTitle[5].width + 'px'}">
				{{item.cost || 0}}
			</div>
			<!-- 展示数 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[6].width + 'px'}">
				{{item.show || 0}}
			</div>
			<!-- ecpm -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[7].width + 'px'}" >
				{{item.avg_show_cost | tableToFixed}}
			</div>
			<!-- 点击数 -->
			<div  v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[8].width + 'px'}">
				{{item.click || 0}}
			</div>
			<!-- 平均点击单价 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[9].width + 'px'}">
				{{item.avg_click_cost | tableToFixed}}
			</div>
			<!-- 点击率 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[10].width + 'px'}">
				{{item.ctr | tableToFixed}}
			</div>
			
			<!-- 公众号关注数 -->
			<div v-if="page_type == 'mp'" class="table-td-cell text-right" :style="{'width': rableTitle[11].width + 'px'}">
				<!-- mp部分的 -->
				{{item.follow_count || 0}}
			</div>
			<div v-else class="table-td-cell text-right" :style="{'width': rableTitle[11].width + 'px'}">
				<!-- adq部分的 -->
				{{item.from_follow_uv || 0}}
			</div>
			
			
			<!-- 公众号关注成本 -->
			<div v-if="page_type == 'mp'" class="table-td-cell text-right" :style="{'width': rableTitle[12].width + 'px'}">
				<!-- mp部分的 -->
				{{item.follow_cost | tableToFixed}}
			</div>
			<div v-else class="table-td-cell text-right" :style="{'width': rableTitle[12].width + 'px'}">
				<!-- adq部分的 -->
				{{item.from_follow_cost | tableToFixed}}
			</div>
			
			<!-- 公众号关注数(微信) -->
			<div v-if="page_type == 'adq'" class="table-td-cell text-right" :style="{'width': rableTitle[11].width + 'px'}">
				{{item.follow_count || 0}}
			</div>
			<!-- 公众号关注成本(微信) -->
			<div v-if="page_type == 'adq'" class="table-td-cell text-right" :style="{'width': rableTitle[12].width + 'px'}">
				{{item.follow_cost | tableToFixed}}
			</div>
			
			<!-- 转化数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[13+2].width + 'px'}">
				{{item.conversions_count || 0}}
			</div>
			<!-- 平均转化成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[14+2].width + 'px'}">
				{{item.conversions_cost | tableToFixed}}
			</div>
			<!-- 转化率 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[15+2].width + 'px'}">
				{{item.conversions_rate | tableToFixed}}
			</div>
			<!-- 总充值金额 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[16+2].width + 'px'}">
				{{item.eff_total_pay_money || 0}}
			</div>
			<!-- 分成金额 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[17+2].width + 'px'}">
				{{item.eff_total_left_money || 0}}
			</div>
			<!-- 首充分成金额 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[18+2].width + 'px'}">
				{{item.eff_total_left_money_fisrt || 0}}
			</div>
			<!-- ROI -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[19+2].width + 'px'}">
				{{item.eff_roi*100 | tableToFixed}}%
			</div>
			<!-- 首充ROI -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[20+2].width + 'px'}">
				{{item.eff_roi_first*100 | tableToFixed}}%
			</div>
			
			<!-- 当天订单笔数 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[21+2].width + 'px'}">
				{{item.eff_total_order_cnt || 0}}
			</div>
			<!-- 当天充值用户数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[22+2].width + 'px'}">
				{{item.eff_total_pay_user_cnt || 0}}
			</div>
			<!-- 当天充值用户成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[23+2].width + 'px'}">
				{{item.eff_total_pay_user_cost | tableToFixed}}
			</div>
			<!-- ARPU -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[24+2].width + 'px'}">
				{{item.arpu | tableToFixed}}
			</div>
			<!-- 回传用户数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[25+2].width + 'px'}">
				{{item.eff_report_pay_user_cnt || 0}}
			</div>
			<!-- 回传用户成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[26+2].width + 'px'}">
				{{item.eff_report_pay_user_cost | tableToFixed}}
			</div>
			<!-- 账户ID -->
			<div class="table-td-cell" :style="{'width': rableTitle[27+2].width + 'px'}">
				{{item.account_id}}
			</div>
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		
	</div>
</template>

<script>
export default {
	name: 'MPzhTable',
	props: ['rableTitle','tableShowData','tableSumData','table_scroll_width','jj_checked','indeterminate','checkAll','table_null_width','page_type'],
	data(){
		return {
			
			select_sort_index: "", // 筛选的
			
			popover_clicked: false,
			
			sticky_index: 4,
		}
	},
	methods: {
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				
				
				this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		// editTable(index){
		// 	this.$emit('edit-td-click', index)
		// },
		TDmouseenter(index){
			// console.log(index);
		},
		// 操作
		operation(e,item){
			console.log(e,item)
			if(e == 1){ // 点击账户名称
				// 这里使用params方式传参，而不用query是因为，params的参数不会拼在url后面，这样子刷新页面后，传过来的参数就可以自动清空
				// this.$router.replace({name: 'JLggz_',params: {jump_id: item.adv_id}})
			}
			else if(e == 2){ // 点击负责人
				this.$emit('click-Fzr', item)
			}
			else if(e == 3){ // 推广内容
				this.$emit('click-tgnr', item)
			}
		},
		handleClickChange(e,item){
			console.log(e)
			item.popover_clicked = e
		},
		// 2.0操作的气泡框
		handleClickChange2(e,item){
			console.log(e)
			item.popover_clicked2 = e
		},
		// 表格内的操作项
		zhOperation(e,item){
			console.log(item);
			if(e == 1){ // 同步账户信息
				item.popover_clicked = false
				this.$emit('sync-zhxx-click', item, 1)
			}
			else if(e == 2){ // 查看广告
				if(this.page_type == 'mp'){
					this.$router.push({name:'MPgg_',params:{jump_id:item.account_id}})
				}
				else { // ADQ
					this.$router.push({name:'ADQgg_',params:{jump_id:item.account_id}})
				}
			}
			else if(e == 3){ // 查看计划
				if(this.page_type == 'mp'){
					this.$router.push({name:'MPjh_',params:{jump_id: item.account_id}})
				}
				else { // ADQ
					this.$router.push({name:'ADQjh_',params:{jump_id: item.account_id}})
				}
			}
			else if(e == 5){ // 同步历史数据
				item.popover_clicked = false
				this.$emit('sync-zhxx-click', item, 5)
			}
			
		},
		
		// 全选
		onCheckAllChange(e){
			this.$emit('click-All-Checkbox', e)
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			this.$emit('click-Checkbox', checkedList,index)
		},
		
		// 同步2.0数据 开启/关闭
		onSyncCheckbox(e,item){
			this.$emit('sync-Checkbox', e, item)
		}
	},
	filters: {
		bookTypeFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value === 0){
				vvv = "未设置"
			}
			else if(value === 1){
				vvv = "男频"
			}
			else if(value === 2){
				vvv = "女频"
			}
			return vvv
		},
		tableToFixed(value){ // 保留小数点后两位，四舍五入
			// console.log("过滤器",value)
			if(value){
				let v = Number(value)
				return v.toFixed(2)
			}
			else {
				return 0
			}
			
		}
	}
}
</script>

<style scoped>
.cz-button-calss {
	font-size: 13px;
	padding:10px;
	cursor: pointer;
}
.cz-button-calss:hover {
	background-color: #f4f7fa;
}

/* 表格样式-非公共/基础样式 */
.table-th-cell {
	height: 59px;
}
.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}

.table-td-cell {
	font-size: 12px;
}
</style>